import React, { useContext, useState } from 'react';
import { InputField } from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';
import { provideDefault } from '../../flows/shared/utils';
import styles from './style.css';

const FormerEmployer = () => {
  const { formProps } = useContext(FlowContext);

  const [formerEmployerName] = useState('');

  return (
    <>
      <div className="former-employer-field">
        <InputField
          title="Former Employer"
          className="former-employer-input"
          defaultValue={provideDefault(
            formerEmployerName,
            formProps.formerEmployerName
          )}
          {...formProps.formerEmployerName}
        />
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default FormerEmployer;
